import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import DefaultLayout from '@/layouts/default-layout.vue'
import AuthLayout from '@/layouts/auth-layout.vue'
import IdentityCallback from '@/views/authentication/identity-callback.vue'
import { registerGuard } from './router-guard'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/home',
    component: DefaultLayout,
    children: [
      {
        path: 'home',
        name: 'home',
        meta: {
          title: 'Home',
        },
        component: () => import('@/views/home-view.vue'),
      },
      {
        path: 'pull-requests',
        name: 'pull-requests',
        meta: {
          title: 'Pull Requests',
        },
        component: () => import('@/views/pull-requests/pull-requests-view.vue'),
      },
      {
        path: 'configuration',
        name: 'configuration',
        meta: {
          title: 'Configuration',
        },
        component: () => import('@/views/configuration/configuration-view.vue'),
      },
      {
        path: 'secrets',
        name: 'secrets',
        meta: {
          title: 'Secrets',
        },
        component: () => import('@/views/secrets/secrets-view.vue'),
      },
      {
        path: 'features',
        name: 'features',
        redirect: '/features/active',
        children: [
          {
            path: 'rollout',
            name: 'features-rollout',
            meta: {
              title: 'Feature Rollout',
            },
            component: () =>
              import('@/views/features/features-rollout-view.vue'),
          },
          {
            path: 'active',
            name: 'features-active',
            meta: {
              title: 'Active Features',
            },
            component: () =>
              import('@/views/features/features-active-view.vue'),
          },
          {
            path: 'permanent',
            name: 'features-permanent',
            meta: {
              title: 'Permanent Features',
            },
            component: () =>
              import('@/views/features/features-permanent-view.vue'),
          },
          {
            path: 'deprecated',
            name: 'features-deprecated',
            meta: {
              title: 'Deprecated Features',
            },
            component: () =>
              import('@/views/features/features-deprecated-view.vue'),
          },
        ],
      },
      {
        path: 'deployments',
        name: 'deployments',
        redirect: '/deployments/production',
        children: [
          {
            path: ':environmentId',
            name: 'deployments-environment',
            meta: {
              title: 'Recent Deployments',
            },
            component: () =>
              import('@/views/deployments/deployments-recent-view.vue'),
          },
        ],
      },
      {
        path: 'deployment-overview',
        name: 'deployment-overview',
        meta: {
          title: 'Deployment Overview',
        },
        component: () =>
          import('@/views/deployments/deployment-overview-view.vue'),
      },
      {
        path: 'networking',
        name: 'networking',
        redirect: '/networking/subdomains',
        children: [
          {
            path: 'subdomains',
            name: 'networking-subdomains',
            meta: {
              title: 'Subdomains',
            },
            component: () => import('@/views/networking/subdomains-view.vue'),
          },
        ],
      },
      {
        path: 'telephony',
        name: 'telephony',
        redirect: '/telephony/phone-numbers',
        children: [
          {
            path: 'phone-numbers',
            name: 'telephony-phone-numbers',
            meta: {
              title: 'Phone Numbers',
            },
            component: () => import('@/views/telephony/phone-numbers-view.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/identity/callback',
    component: AuthLayout,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        name: 'identityCallback',
        component: IdentityCallback,
      },
    ],
  },
  {
    path: '/signin/error',
    name: 'signinError',
    component: () => import('@/views/authentication/signin-error.vue'),
    meta: {
      title: 'Signin Error',
    },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

registerGuard(router)

export default router
